import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import HomePage from 'pages/HomePage'
import HospitalProfile from 'pages/Hospitals/Profile/index'
import UserProfile from 'pages/Users/Profile'
import EmployerCandidateMatchListPage from 'pages/Hospitals/Candidates/EmployerCandidateMatchListPage'
import JobFormPage from 'pages/Hospitals/Jobs/JobFormPage'
import JobsList from 'pages/Jobs/index'
import JobDetails from 'pages/Jobs/JobDetails'
import PhysiciansList from 'pages/Physicians/index'
import Connections from 'pages/Hospitals/Connections/index'
import About from 'pages/About/index'
import Employers from './pages/Super/Employers'
import EmployerUsers from './pages/Super/EmployerUsers'
import Login from 'pages/Identity/Login'
import CreatePassword from 'pages/Identity/CreatePassword'
import ResendConfirmationLink from 'pages/Identity/ResendConfirmationLink'
import SendResetPasswordLink from 'pages/Identity/SendResetPasswordLink'
import ResetPassword from 'pages/Identity/ResetPassword'
import EmailConfirmation from 'pages/Register/EmailConfirmation'
import { ReduxRouter } from '@lagunovsky/redux-react-router'
import Filters from 'pages/Users/Filters'
import Alerts from 'pages/Users/Alerts'
import HospitalRegister from 'pages/HospitalSignup'
import PhysicianRegister from 'pages/Register/Physicians'
import Layout from 'components/Layout'
import TermsAndConditionsV2 from 'pages/Legal/TermsAndConditionsV2'
import PrivacyPolicyV2 from 'pages/Legal/PrivacyPolicyV2'
import CandidatesSuper from 'pages/Super/Candidates'
import PartnerInterest from 'pages/Super/PartnerInterest'
import JobInterest from './pages/Super/JobInterest'
import Users from './pages/Admin/Users'
import Onboarding from './pages/Onboarding'
import CandidateProfile from './pages/Users/Profile/CandidateProfile'
import EmployerUserProfile from './pages/Users/Profile/EmployerProfile'
import Housing from './pages/Housing'
import Applications from './pages/Applications'
import SuperJobs from './pages/Super/Jobs'
import JobDetailPage from './pages/Jobs/AI/JobDetailPage'
import Directory from './pages/Directory'
import Salary from './pages/Salary'
import Careers from './pages/Careers'
import ResidencyTransfer from './pages/ResidencyTransfer'
import SuperHousing from './pages/Super/Housing'
import SpecialtySynonyms from './pages/Super/SpecialtySynonyms'
import BackgroundJobLauncher from './pages/Super/BackgroundJobLauncher'
import ScheduledBackgroundJobs from './pages/Super/ScheduledBackgroundJobs'
import ChatbotDashboard from './pages/Super/ChatbotDashboard'
import ChatbotConversations from './pages/Super/ChatbotConversations'
import EmployerKioskPage from './pages/Super/EmployerKioskPage'
import Resources from './pages/Resources'
import AAPPR2026 from './pages/AAPPR2026'
import EmployerCandidateProfilePage from './pages/Hospitals/Candidates/EmployerCandidateProfilePage'
import RecruiterLandingPage from './pages/Recruiters'
import EmployerLandingPage from './pages/Employers/EmployerLandingPage'
import RequestDemo from './pages/Contact/RequestDemo'
import ContactUs from './pages/Contact/ContactUs'
import Support from './pages/Contact/Support'



const PrivateRoute = ({ children }) => {
  const location = useLocation()
  const signedIn = useSelector(state => state.identity.signedIn)
  if (!signedIn) {
    return (
      <Navigate to='/login' state={{ from: `${location.pathname}${location.search}` }} replace />
    )
  }

  return children
}

const PublicPrivateRoute = ({ children }) => {
  const location = useLocation()
  const signedIn = useSelector(state => state.identity.signedIn)
  if (location.search) {
    const queryParams = new URLSearchParams(location.search)
    const shouldLogin =
      queryParams.get('login') === 'true' || queryParams.get('clickFrom') === 'email'
    if (!signedIn && shouldLogin) {
      queryParams.delete('login')
      return (
        <Navigate
          to='/login'
          state={{ from: `${location.pathname}?${queryParams.toString()}` }}
          replace
        />
      )
    }
  }

  return children
}

// TODO:BROCK nested routes and outlets could cut down on cruft here: https://blog.logrocket.com/complete-guide-authentication-with-react-router-v6/

export default history => {
  return (
    <ReduxRouter history={history}>
      <Layout>
        <Routes>
          <Route path='/' element={<HomePage />} />

          <Route path='/login' element={<Login />} />
          <Route path='/housing' element={<Housing />} />
          <Route path='/directory' element={<Directory />} />
          <Route path='/salary' element={<Salary />} />
          <Route path='/residency-transfer' element={<ResidencyTransfer />} />

          <Route path='/candidate/email_confirmation_prompt' element={<EmailConfirmation />} />
          <Route path='/create_password' element={<CreatePassword />} />
          <Route path='/resend_confirmation_link' element={<ResendConfirmationLink />} />
          <Route path='/send_reset_password_link' element={<SendResetPasswordLink />} />
          <Route path='/reset_password' element={<ResetPassword />} />

          <Route path='/about' element={<About />} />
          <Route path='/recruiters' element={<RecruiterLandingPage />} />
          <Route path='/employers' element={<EmployerLandingPage />} />
          <Route path='/demo' element={<RequestDemo />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path='/register/hospitals' element={<HospitalRegister />} />
          <Route path='/register/physicians' element={<PhysicianRegister />} />
          <Route path='/resources' element={<Resources />} />
          <Route path='/aappr-2026' element={<AAPPR2026 />} />
          <Route
            path='/super/jobs'
            element={
              <PrivateRoute>
                <SuperJobs />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/employers'
            element={
              <PrivateRoute>
                <Employers />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/employer_users'
            element={
              <PrivateRoute>
                <EmployerUsers />
              </PrivateRoute>
            }
          />
          <Route
            path='/admin/users'
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/candidates'
            element={
              <PrivateRoute>
                <CandidatesSuper />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/partner_interest'
            element={
              <PrivateRoute>
                <PartnerInterest />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/job_interest'
            element={
              <PrivateRoute>
                <JobInterest />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/specialty_synonyms'
            element={
              <PrivateRoute>
                <SpecialtySynonyms />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/housing'
            element={
              <PrivateRoute>
                <SuperHousing />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/background_jobs'
            element={
              <PrivateRoute>
                <BackgroundJobLauncher />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/scheduled-background-jobs'
            element={
              <PrivateRoute>
                <ScheduledBackgroundJobs />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/chatbot_dashboard'
            element={
              <PrivateRoute>
                <ChatbotDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/chatbot_conversations'
            element={
              <PrivateRoute>
                <ChatbotConversations />
              </PrivateRoute>
            }
          />
          <Route
            path='/super/employer-kiosk'
            element={
              <PrivateRoute>
                <EmployerKioskPage />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/profile'
            element={
              <PrivateRoute>
                <HospitalProfile />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/candidates/:id'
            element={
              <PrivateRoute>
                <EmployerCandidateProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/candidates'
            element={
              <PrivateRoute>
                <EmployerCandidateMatchListPage />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/jobs/new'
            element={
              <PrivateRoute>
                <JobFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/jobs/:id/edit'
            element={
              <PrivateRoute>
                <JobFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path='/onboarding'
            element={
              <PrivateRoute>
                <Onboarding />
              </PrivateRoute>
            }
          />
          <Route
            path='/hospitals/connections'
            element={
              <PrivateRoute>
                <Connections />
              </PrivateRoute>
            }
          />

          <Route
            path='/jobs/ai/:id'
            element={
              <PublicPrivateRoute>
                <JobDetailPage />
              </PublicPrivateRoute>
            }
          />
          <Route
            path='/jobs'
            element={
              <PublicPrivateRoute>
                <JobsList />
              </PublicPrivateRoute>
            }
          />
          <Route path='/jobs/:id' element={<JobDetails />} />
          <Route path='/dashboard/jobs/:id' element={<JobDetails />} />
          <Route
            path='/applications'
            element={
              <PrivateRoute>
                <Applications />
              </PrivateRoute>
            }
          />
          <Route
            path='/physicians'
            element={
              <PrivateRoute>
                <PhysiciansList />
              </PrivateRoute>
            }
          />

          <Route
            path='/users/candidate/profile/'
            element={
              <PrivateRoute>
                <CandidateProfile />
              </PrivateRoute>
            }
          />
          <Route
            path='/users/employer_user/profile/'
            element={
              <PrivateRoute>
                <EmployerUserProfile />
              </PrivateRoute>
            }
          />
          <Route
            path='/users/profile/:id'
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route
            path='/users/filters'
            element={
              <PrivateRoute>
                <Filters />
              </PrivateRoute>
            }
          />

          <Route
            path='/users/alerts'
            element={
              <PrivateRoute>
                <Alerts />
              </PrivateRoute>
            }
          />
          <Route
            path='users/alerts/alert-records'
            element={
              <PrivateRoute>
                <Alerts />
              </PrivateRoute>
            }
          />
          <Route path='/recruiters/profile/:id' element={<UserProfile />} />
          <Route
            path='/support'
            element={
              <PrivateRoute>
                <Support />
              </PrivateRoute>
            }
          />
          <Route path='/tac' element={<TermsAndConditionsV2 />} />
          <Route path='/privacy' element={<PrivacyPolicyV2 />} />
          <Route path='/careers' element={<Careers />} />
        </Routes>
      </Layout>
    </ReduxRouter>
  )
}
